import React from 'react';
import QuestionCard from '../forms/QuestionCard';
import { useFormContext } from '../../context/FormContext';

const DecisionMakingQuestions = ({
  questionNumber,
  categories,
  totalQuestions
}) => {
  const { formData, handleInputChange } = useFormContext();
  
  switch(questionNumber) {
    case 1:
      return (
        <QuestionCard 
          categoryIcon={categories[6].icon}
          categoryName={categories[6].name}
          questionNumber={1}
          totalQuestions={totalQuestions}
          title="在没有完整信息的情况下，你更倾向于依靠你的直觉进行判断，还是尽可能收集更多数据后才做决定?" 
          value={formData.decisionMakingStyle}
          onChange={(value) => handleInputChange('decisionMakingStyle', value)}
          inputType="textarea"
        />
      );
    case 2:
      return (
        <QuestionCard 
          categoryIcon={categories[6].icon}
          categoryName={categories[6].name}
          questionNumber={2}
          totalQuestions={totalQuestions}
          title="你是一个注重细节的人吗，还是觉得大方向对就可以了，对于抠细节没那么有耐心?" 
          value={formData.attentionToDetail}
          onChange={(value) => handleInputChange('attentionToDetail', value)}
          inputType="textarea"
        />
      );
    case 3:
      return (
        <QuestionCard 
          categoryIcon={categories[6].icon}
          categoryName={categories[6].name}
          questionNumber={3}
          totalQuestions={totalQuestions}
          title="想象你今天刚认识了一个新朋友，朋友或者你爸妈问你：&quot;这个人怎么样？&quot;（也可以尝试回忆一个实际发生过的该情境）你会怎么回答？请写出你会说的话。" 
          value={formData.personDescription}
          onChange={(value) => handleInputChange('personDescription', value)}
          inputType="textarea"
        />
      );
    case 4:
      return (
        <QuestionCard 
          categoryIcon={categories[6].icon}
          categoryName={categories[6].name}
          questionNumber={4}
          totalQuestions={totalQuestions}
          title="回想你上一次安排假期出游：你是提前订好酒店、交通、景点票、每天路线都写好的人？还是只订机票/酒店，到时候再决定每天去哪玩?" 
          value={formData.vacationPlanning}
          onChange={(value) => handleInputChange('vacationPlanning', value)}
          inputType="textarea"
        />
      );
    case 5:
      return (
        <QuestionCard 
          categoryIcon={categories[6].icon}
          categoryName={categories[6].name}
          questionNumber={5}
          totalQuestions={totalQuestions}
          title="如果你申请大学的时候只能选 5 所学校，你觉得你更可能怎么分配？" 
          subtitle="（可以回忆一下你当时冲刺校和保底校的比例大概是多少，是怎么权衡&quot;冲一冲&quot;和&quot;稳一点&quot;的选择的）"
          inputType="radio"
          options={[
            "A. 多选几所我最想去的、虽然录上不确定",
            "B. 多选几所我把握大、录上概率高的",
            "C. 当时不太是我自己主导决定的 / 说不上来",
          ]}
          value={formData.riskPreference}
          onChange={(value) => handleInputChange('riskPreference', value)}
        />
      );
    case 6:
      return (
        <QuestionCard 
          categoryIcon={categories[6].icon}
          categoryName={categories[6].name}
          questionNumber={6}
          totalQuestions={totalQuestions}
          title="你觉得你更像哪种类型的人？" 
          inputType="radio"
          options={[
            "A. 宁愿多试错一次，也不愿错过一个机会",
            "B. 宁可稳一点，别浪费精力和情绪",
            "C. 说不太清楚",
          ]}
          value={formData.riskType}
          onChange={(value) => handleInputChange('riskType', value)}
        />
      );
    default:
      return null;
  }
};

export default DecisionMakingQuestions;